if (!customElements.get('load-more')) {
  customElements.define(
    'load-more',
    class LoadMore extends HTMLElement {
      connectedCallback() {
        if (this.dataset.connected === 'true') return;
        this.dataset.connected = 'true';

        this.grid = document.getElementById('product-grid');
        this.button = this.querySelector('[data-load-more-button]');
        this.progress = this.querySelector('[data-load-more-progress]');
        this.status = this.querySelector('[data-load-more-status]');
        this.error = this.querySelector('[data-load-more-error]');
        this.controls = this.querySelector('[data-load-more-controls]');
        this.spinner = this.button?.querySelector('.loading__spinner');

        this.sectionId = this.dataset.sectionId;
        this.nextUrl = this.dataset.nextUrl || '';
        this.shown = Number(this.dataset.shown) || 0;
        this.total = Number(this.dataset.total) || 0;
        this.statusTemplate = this.dataset.statusTemplate || '';
        this.loading = false;
        this.abortController = null;

        this.onButtonClick = (event) => {
          event.preventDefault();
          this.loadNext();
        };
        this.onHostClick = (event) => {
          if (event.target.closest('[data-load-more-button]')) {
            event.preventDefault();
            this.loadNext();
          }
        };

        this.addEventListener('click', this.onHostClick);
        this.button?.addEventListener('click', this.onButtonClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onButtonClick);
        this.removeEventListener('click', this.onHostClick);
        this.abortController?.abort();
        this.dataset.connected = 'false';
      }

      async loadNext() {
        if (this.loading || !this.nextUrl || !this.grid || !this.sectionId) return;

        this.loading = true;
        this.setLoading(true);
        this.hideError();

        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);

        this.abortController = new AbortController();

        try {
          const response = await fetch(url.toString(), { signal: this.abortController.signal });
          if (!response.ok) throw new Error('Failed to load products');

          const htmlText = await response.text();
          const doc = new DOMParser().parseFromString(htmlText, 'text/html');
          const newGrid = doc.getElementById('product-grid');
          const newLoadMore = doc.querySelector('load-more');

          if (!newGrid) throw new Error('Missing product grid');

          const items = Array.from(newGrid.querySelectorAll(':scope > li'));
          items.forEach((item) => {
            item.querySelectorAll('.scroll-trigger').forEach((el) => {
              el.classList.add('scroll-trigger--cancel');
            });
            this.grid.appendChild(item);
          });

          this.shown += items.length;
          this.dataset.shown = String(this.shown);
          this.updateProgress();

          const nextUrl = newLoadMore?.dataset.nextUrl || '';
          this.nextUrl = nextUrl;
          this.dataset.nextUrl = nextUrl;

          if (!nextUrl) this.finish();
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.showError();
        } finally {
          this.loading = false;
          this.setLoading(false);
        }
      }

      updateProgress() {
        if (this.status && this.statusTemplate) {
          this.status.textContent = this.statusTemplate
            .replace('__SHOWN__', String(this.shown))
            .replace('__TOTAL__', String(this.total));
        }

        if (this.progress) {
          this.progress.max = this.total;
          this.progress.value = this.shown;
        }
      }

      finish() {
        if (this.controls) this.controls.hidden = true;
        this.nextUrl = '';
        this.dataset.nextUrl = '';
      }

      setLoading(isLoading) {
        if (!this.button) return;
        this.button.disabled = isLoading;
        this.button.classList.toggle('loading', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);
      }

      showError() {
        if (this.error) this.error.hidden = false;
      }

      hideError() {
        if (this.error) this.error.hidden = true;
      }
    }
  );
}
